(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hp-newsletter-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('hp-newsletter-popup');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const key = 'hp-newsletter-seen-v1';
    const preview = new URLSearchParams(location.search).get('newsletter_preview') === '1';
    let shown = false;
    let ready = false;
    const recentlySeen = () => {
      try { return Date.now() - Number(localStorage.getItem(key) || 0) < 604800000; }
      catch { return false; }
    };
    const remember = () => {
      try { localStorage.setItem(key, String(Date.now())); } catch {}
    };
    const show = () => {
      if (shown || !ready || document.hidden || (!preview && recentlySeen())) return;
      if (document.querySelector('dialog[open], cart-drawer.active, details[open] menu-drawer')) return;
      if (document.activeElement?.matches('input, textarea, select')) return;
      shown = true;
      dialog.querySelector('iframe').src = dialog.querySelector('iframe').dataset.src;
      dialog.showModal();
      if (!preview) remember();
      window.removeEventListener('scroll', onScroll);
    };
    const onScroll = () => { if (window.scrollY > 160) show(); };
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    if (preview) { ready = true; show(); return; }
    if (window.Shopify?.designMode || recentlySeen()) return;
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(() => { ready = true; if (matchMedia('(min-width: 750px)').matches || window.scrollY > 160) show(); }, 6000);
  })();
  } catch(e) { console.error(e); }
})();

})();
